import React from 'react';

import Table from '../components/Beacons/Table/Table';

function Beacons() {
  return <Table />;
}

export default Beacons;
